import { makeDefaultPorts } from '../../utils/ports';
import type { EquipmentTemplate } from './equipmentTypes';

export const PROCESS_TOOL_TEMPLATE_ID = 'builtin-awp-300';
/** @deprecated alias */
export const AWP300_TEMPLATE_ID = PROCESS_TOOL_TEMPLATE_ID;

/** Canonical fab process tool template (single 3D/2D kit for all tool types). */
export const PROCESS_TOOL_EQUIPMENT_TEMPLATE: EquipmentTemplate = {
  id: PROCESS_TOOL_TEMPLATE_ID,
  name: 'Process Tool',
  objectType: 'equipment',
  category: 'CVD',
  icon: '⚗',
  defaultStyle: {
    color: '#0ea5e9',
    fillOpacity: 0.22,
    icon: '⚗',
  },
  ports: makeDefaultPorts({ parentId: PROCESS_TOOL_TEMPLATE_ID, parentType: 'equipment' }),
  defaultProperties: {
    equipmentModel: 'Process Tool',
    processType: 'PHOTO',
    portCount: 2,
    vendor: 'Reference Design',
    description: 'Standard fab process module — dual load ports; set Process Type for label color.',
  },
  metadata: {
    source: 'builtin',
    revision: '1.0',
  },
  createdAt: '2026-01-01T00:00:00.000Z',
  updatedAt: '2026-01-01T00:00:00.000Z',
};

export const NEW_OHT_LOAD_PORT_TEMPLATE_ID = 'builtin-oht-load-port-equipment';

/** New Semiconductor FAB Equipment Enclosure with direct overhead OHT load-port opening. */
export const NEW_OHT_LOAD_PORT_EQUIPMENT_TEMPLATE: EquipmentTemplate = {
  id: NEW_OHT_LOAD_PORT_TEMPLATE_ID,
  name: 'OHT Load-Port Equipment (AT3-300)',
  objectType: 'equipment',
  category: 'etch',
  icon: '⚡',
  defaultStyle: {
    color: '#0ea5e9',
    fillOpacity: 0.22,
    icon: '⚡',
  },
  ports: makeDefaultPorts({ parentId: NEW_OHT_LOAD_PORT_TEMPLATE_ID, parentType: 'equipment' }),
  defaultProperties: {
    equipmentModel: 'AT3-300',
    equipmentType: 'OHT_LOAD_PORT',
    processType: 'ETCH',
    portCount: 2,
    vendor: 'Antigravity Semiconductor Equipment',
    description: 'Dark navy enclosure with white frame and upper front recessed OHT load-port interface.',
  },
  metadata: {
    source: 'builtin',
    revision: '1.0',
  },
  createdAt: '2026-01-01T00:00:00.000Z',
  updatedAt: '2026-01-01T00:00:00.000Z',
};

/** @deprecated alias */
export const AWP300_EQUIPMENT_TEMPLATE = PROCESS_TOOL_EQUIPMENT_TEMPLATE;

export const BUILT_IN_EQUIPMENT_TEMPLATES: readonly EquipmentTemplate[] = [
  PROCESS_TOOL_EQUIPMENT_TEMPLATE,
];

/** Ensure catalog templates exist without overwriting user edits. */
export function mergeBuiltInEquipmentTemplates(
  templates: Record<string, EquipmentTemplate>,
  templateOrder: string[]
): { templates: Record<string, EquipmentTemplate>; templateOrder: string[] } {
  const nextTemplates = { ...templates };
  const nextOrder = [...templateOrder];
  for (const builtIn of BUILT_IN_EQUIPMENT_TEMPLATES) {
    if (!nextTemplates[builtIn.id]) {
      nextTemplates[builtIn.id] = builtIn;
      nextOrder.unshift(builtIn.id);
    }
  }
  return { templates: nextTemplates, templateOrder: nextOrder };
}
